import React from 'react';

import moment from 'moment';
import 'moment/locale/es';
import { Button, Radio } from 'antd/lib';
import { Form } from '@ant-design/compatible';

// import SelectorModelo from './SelectorModelo'
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
moment.locale();

class FormClaseViolencia extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id_nota: '',
      date: null,
      confirmDirty: false,
      autoCompleteResult: [],
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let valor = this.evaluarPuntaje(values);

        let respuestas = {
          ...values,
          valor,
        };

        // console.log(this.props);
        this.props.onSubmit(respuestas);
      }
    });
  };

  evaluarPuntaje = respuestas => {
    // console.log("Entre a evaluar el puntaje con....");
    // console.log(respuestas);

    let valor = 0;
    //Lo que busco a continuacion es sumar los valores, pero como estan en STRINGS, primero debo aplicar el operador UNARIO + para convertirlos a INT.
    valor =
      +respuestas.violenciaFisica +
      +respuestas.agresionVerbal +
      +respuestas.violenciaSexual +
      +respuestas.violenciaEconomica +
      +respuestas.restriccionSocial +
      +respuestas.violenciaAmbiental +
      +respuestas.violenciaSimbolica;

    // console.log("El resultado es.... ", valor);

    return valor;
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  render() {
    moment.locale();
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div>
        <h1 className="tituloForm">Evaluación Clase de Violencia</h1>

        <Form onSubmit={this.handleSubmit} className="formulariosViolencia">
          {' '}
          <FormItem {...formItemLayout} label="Violencia Fisica">
            {getFieldDecorator('violenciaFisica', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar la clasificacion!',
                },
              ],
            })(
              <RadioGroup>
                <Radio value="0">0</Radio>
                <Radio value="1">1</Radio>
                <Radio value="2">2</Radio>
                <Radio value="3">3</Radio>
                <Radio value="4">4</Radio>
              </RadioGroup>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Agresión verbal/psicol/emocional"
          >
            {getFieldDecorator('agresionVerbal', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar la clasificacion!',
                },
              ],
            })(
              <RadioGroup>
                <Radio value="0">0</Radio>
                <Radio value="1">1</Radio>
                <Radio value="2">2</Radio>
                <Radio value="3">3</Radio>
                <Radio value="4">4</Radio>
              </RadioGroup>
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="Violencia sexual/reproductiva">
            {getFieldDecorator('violenciaSexual', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar la clasificacion!',
                },
              ],
            })(
              <RadioGroup>
                <Radio value="0">0</Radio>
                <Radio value="1">1</Radio>
                <Radio value="2">2</Radio>
                <Radio value="3">3</Radio>
                <Radio value="4">4</Radio>
              </RadioGroup>
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="Violencia económica/patrimonial">
            {getFieldDecorator('violenciaEconomica', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar la clasificacion!',
                },
              ],
            })(
              <RadioGroup>
                <Radio value="0">0</Radio>
                <Radio value="1">1</Radio>
                <Radio value="2">2</Radio>
                <Radio value="3">3</Radio>
                <Radio value="4">4</Radio>
              </RadioGroup>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Restricción participacion social"
          >
            {getFieldDecorator('restriccionSocial', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar la clasificacion!',
                },
              ],
            })(
              <RadioGroup>
                <Radio value="0">0</Radio>
                <Radio value="1">1</Radio>
                <Radio value="2">2</Radio>
                <Radio value="3">3</Radio>
                <Radio value="4">4</Radio>
              </RadioGroup>
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="Violencia ambiental">
            {getFieldDecorator('violenciaAmbiental', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar la clasificacion!',
                },
              ],
            })(
              <RadioGroup>
                <Radio value="0">0</Radio>
                <Radio value="1">1</Radio>
                <Radio value="2">2</Radio>
                <Radio value="3">3</Radio>
                <Radio value="4">4</Radio>
              </RadioGroup>
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="Violencia Simbólica">
            {getFieldDecorator('violenciaSimbolica', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar la clasificacion!',
                },
              ],
            })(
              <RadioGroup>
                <Radio value="0">0</Radio>
                <Radio value="1">1</Radio>
                <Radio value="2">2</Radio>
                <Radio value="3">3</Radio>
                <Radio value="4">4</Radio>
              </RadioGroup>
            )}
          </FormItem>
          <FormItem {...tailFormItemLayout}>
            <Button style={{ margin: 10 }} type="primary" htmlType="submit">
              Siguiente
            </Button>
            <Button
              style={{ margin: 10 }}
              type="danger"
              onClick={this.props.onCancel}
            >
              Cancelar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(FormClaseViolencia);
